export default {
	path: '/',
	icon: '',
	meta: {
		title: '产品运营中心'
	},
	children: [
		{
			path: '/',
			icon: '',
			component: '',
			meta: {
				title: '产品管理'
			},
			children: [
				{
					path: '/order/productProject',
					name: 'ProductProjectIndex',
					icon: '',
					ignore: true, //忽略权限校验
					component: () => import('@/views/order/educationalAdministration/productProject'),
					meta: {
						title: '产品项目'
					}
				},
				{
					path: '/order/myProduct',
					name: 'MyProductIndex',
					icon: '',
					ignore: true, //忽略权限校验
					component: () => import('@/views/order/educationalAdministration/myProduct'),
					meta: {
						title: '产品审核'
					}
				},
				{
					path: '/order/computeProduct',
					name: 'ComputeProductIndex',
					icon: '',
					ignore: true, //忽略权限校验
					component: () => import('@/views/order/educationalAdministration/computeProduct'),
					meta: {
						title: '产品统计'
					}
				},
				{
					path: '/order/computeProductXieYi',
					name: 'computeProductXieYi',
					icon: '',
					ignore: true, //忽略权限校验
					component: () => import('@/views/operate/computeProductXieYi'),
					meta: {
						title: '协议统计'
					}
				}
			]
		},

		{
			path: '/operate/home',
			name: 'OpHomeIndex',
			icon: '',
			component: () => import('@/views/operate/home'),
			power: 'admin/v1/day',
			meta: {
				title: '公告管理'
			}
		},
		{
			path: '/operate/operate',
			name: 'OPoperateIndex',
			icon: '',
			component: () => import('@/views/operate/operate'),
			meta: {
				title: '运营项目'
			}
		},
		{
			path: '/operate/map',
			name: 'mapindex',
			icon: '',
			component: () => import('@/views/operate/map'),
			meta: {
				title: '地图'
			}
		},
		{
			path: '/operate/calendar',
			name: 'CalendarIndex',
			icon: '',
			component: () => import('@/views/operate/calendar'),
			meta: {
				title: '日历'
			}
		}
	]
}
